// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__bl0S6","label":"Radio_label__1vz9p","checkMark":"Radio_checkMark__2HpQj","disabled":"Radio_disabled__jpNoV"};